export default __webpack_public_path__ + "static/media/mugglemore-logo.7ffda468.png";